import React from 'react';

export const RefetchContext = React.createContext({});
export const useRefetchContext = () => React.useContext(RefetchContext);
